import { replace } from 'connected-react-router'
import {
  QUICK_APPOINTMENT_PAGE,
  QUOTE_SUMMARY_PAGE,
  DATE_TIME_SELECTOR_TARGET_ID
} from 'constant'
import { getPageLocation } from 'selectors'
import { getIsFromOnlineAppointment } from './helpers'

export const navigateBack = () => (dispatch, getState) => {
  const state = getState()
  const location = getPageLocation(state)
  const quotePageURL = QUOTE_SUMMARY_PAGE
  const isFromOnlineAppointment = getIsFromOnlineAppointment(location)
  const newUrl = `${isFromOnlineAppointment ? QUICK_APPOINTMENT_PAGE : quotePageURL}#${DATE_TIME_SELECTOR_TARGET_ID}`
  dispatch(replace(newUrl))
}
